import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

export const useSetupYupLocale = () => {
  const { t } = useTranslation('layouts/pm');

  useEffect(() => {
    try {
      yup.setLocale({
        mixed: {
          notType: t('invalid'),
        },
      });
    } catch (error) {
      console.error('Error setting yup locale', error);
    }
  }, [t]);
};
